import { AxiosResponse } from 'axios';
import http from '../common/http';
import { UserRole } from '../common/enums/UserRole';
import { CreateUserRequestPayload } from '../components/AdminDashboard/Pages/Administrators/Interfaces/CreateUserRequestPayload';

export interface UpdateUserRequestPayload {
  firstName: string;
  lastName: string;
  companyName: string;
  // todo add email changing
  // email: string;
}

class UserService {
  getUser(id: string): Promise<AxiosResponse> {
    return http.get(`/users/${id}`);
  }

  getMe(): Promise<AxiosResponse> {
    return http.get(`/users/me`);
  }

  deleteMe(password: string): Promise<AxiosResponse> {
    return http.patch(`/users/me/remove`, { password });
  }

  getUsers(params?: { role: UserRole }): Promise<AxiosResponse> {
    return http.get(`/users/`, { params });
  }

  deleteUser(id: string): Promise<AxiosResponse> {
    return http.delete(`/users/${id}`);
  }

  updateUser(body: UpdateUserRequestPayload): Promise<AxiosResponse> {
    return http.patch(`/users`, body);
  }

  createUser(body: CreateUserRequestPayload): Promise<AxiosResponse> {
    return http.post(`/invites`, body);
  }

  getUserRoles(): Promise<AxiosResponse> {
    return http.get(`/roles`);
  }
}

export default new UserService();
